import { ref, computed } from 'vue';
import ImageHighlight from './component-lib.esm3.js';
import RatioBox from '../ratio-box/component-lib.esm.js';

//
var script = {
  name: 'ImageWithHighlights',
  components: {
    ImageHighlight,
    RatioBox
  },
  props: {
    imgAttrs: {
      type: Object,
      required: true
    },
    highlights: {
      type: Array,
      default: () => []
    },
    ratio: {
      type: Number,
      default: null
    },
    showHighlights: Boolean,
    /** Index of the highlight to edit */
    editHighlight: {
      type: Number,
      default: null
    }
  },
  setup(props, _ref) {
    let {
      emit
    } = _ref;
    const root = ref(null);
    const imgHasLoaded = ref(false);
    const isEditing = computed(() => props.editHighlight >= 0 && props.editHighlight !== null);
    const classes = computed(() => {
      return {
        'v-img-wh--editing': isEditing.value
      };
    });
    function handleImgLoad() {
      imgHasLoaded.value = true;
    }
    function handleClick(e) {
      if (!imgHasLoaded.value) {
        return;
      }
      const rect = root.value.getBoundingClientRect();
      // Get the position of the click inside of the element
      const x = e.clientX - rect.left - 20;
      const y = e.clientY - rect.top - 20;
      // Get the percent position
      const left = `${x / rect.width * 100}%`;
      const top = `${y / rect.height * 100}%`;
      emit('edit', {
        index: props.editHighlight,
        top,
        left
      });
    }
    return {
      root,
      isEditing,
      classes,
      handleClick,
      handleImgLoad,
      imgHasLoaded
    };
  }
};
export { script as default };